import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { httpTdgCertificateDetails } from '../../../Hooks/user/user.put.hooks';
import { httpUploadCertificate } from '../../../Hooks/user/user.post.hooks';
import PrimaryButton from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import { generateCertTDG } from './TDGCertGenerator';
import { generateCertBlobTdg } from './TDGCertBlob';

// Creates the certificate for TDG
const TDGCertificate = ({
  name,
  dateCompleted,
  expiryDate,
  employer,
  address,
  updatedCourse,
  courseId,
  userId,
  setSubmitted,
}) => {
  const [disabled, setDisabled] = useState(false);
  useEffect(() => {
    if (name && dateCompleted && expiryDate && employer && address) {
      setDisabled(true);
    }
  }, [name, dateCompleted, expiryDate, employer, address]);

  const generateAndUploadCertificate = async () => {
    try {
      const pdfBlob = await generateCertBlobTdg(
        name,
        dateCompleted,
        expiryDate,
        employer,
        address
      );
      const formData = new FormData();
      formData.append('certificate', pdfBlob, `${name}-TDG.pdf`);
      formData.append('userId', userId);
      formData.append('courseId', courseId);
      const response = await httpUploadCertificate(formData);
      if (response.ok) {
        setSubmitted(true);
      } else {
        setSubmitted(false);
      }
    } catch (error) {
      setSubmitted(false);
    }
  };
  const downloadCertificate = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    generateCertTDG(name, dateCompleted, expiryDate, employer, address);
    await httpTdgCertificateDetails(updatedCourse, courseId, userId);
    await generateAndUploadCertificate();
  };
  return (
    <>
      <PrimaryButton
        span="Download Certificate"
        disabled={!disabled}
        functionName={downloadCertificate}
      />
    </>
  );
};
TDGCertificate.propTypes = {
  name: PropTypes.string,
  course: PropTypes.string,
  dateCompleted: PropTypes.string,
  expiryDate: PropTypes.string,
  employer: PropTypes.string,
  address: PropTypes.string,
  updatedCourse: PropTypes.object,
  courseId: PropTypes.string,
  userId: PropTypes.string,
  setSubmitted: PropTypes.func,
};

export default TDGCertificate;
